"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const compliance_pool_types_1 = require("../../compliance-pool-types");
const common_styled_components_1 = require("../../../common-styled-components");
const react_1 = require("react");
const theme_1 = require("../../../../theme");
const TransactionReviewModal_1 = require("../modals/TransactionReviewModal");
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const useFetchBlob_1 = __importDefault(require("../../../../hooks/useFetchBlob"));
const apiUtils_1 = require("../../../../util/apiUtils");
const useEdit_1 = __importDefault(require("../../../../hooks/useEdit"));
const amountUtils_1 = require("../../../../util/amountUtils");
const Modal_1 = require("../Modal");
const useSortedData_1 = require("../../../../hooks/useSortedData");
const lodash_1 = require("lodash");
const YearContext_1 = require("../../../../contexts/YearContext");
const timeUtils_1 = require("../../../../util/timeUtils");
const ExportCsvButton_1 = require("../ExportCsvButton");
const routes_1 = require("../../../../util/routes");
const tableColumns = (isInAdminTools) => {
    if (isInAdminTools) {
        return [
            {
                key: "transaction_date",
                label: "Date",
                sortableKey: "transaction_date",
            },
            {
                key: "from",
                label: "From",
            },
            {
                key: "to",
                label: "To",
            },
            {
                key: "quantity",
                label: "Quantity (tCO₂e)",
                sortableKey: "quantity",
            },
            {
                key: "transaction_cost",
                label: "Transaction cost (USD)",
                sortableKey: "transaction_cost",
            },
            {
                key: "alternative_cost",
                label: "Alt cost (USD)",
                sortableKey: "alternative_cost",
            },
            {
                key: "sealed_at",
                label: "Sealed",
                sortableKey: "sealed_at",
            },
            {
                key: "tools",
                label: "Tools",
            },
        ];
    }
    return [
        {
            key: "transaction_date",
            label: "Date",
        },
        {
            key: "from",
            label: "From",
        },
        {
            key: "to",
            label: "To",
        },
        {
            key: "quantity",
            label: "Quantity (tCO₂e)",
        },
        {
            key: "sealed_at",
            label: "Sealed",
            sortableKey: "sealed_at",
        },
    ];
};
const getShipLink = (shipId, shipName, transactionCompanyId, isInAdminTools, userCompanyId) => {
    if (isInAdminTools) {
        return ((0, jsx_runtime_1.jsx)(common_styled_components_1.StrippedLink, { to: `${routes_1.routeNames.admin}/${routes_1.routeNames.shipAdmin}/${shipId}`, style: { color: theme_1.theme.colors.blue }, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: shipName }) }));
    }
    else if (userCompanyId !== undefined &&
        transactionCompanyId === userCompanyId) {
        return ((0, jsx_runtime_1.jsx)(common_styled_components_1.StrippedLink, { to: `${routes_1.routeNames.complianceRoot}/${routes_1.routeNames.ship}/${shipId}`, style: { color: theme_1.theme.colors.blue }, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: shipName }) }));
    }
    return (0, jsx_runtime_1.jsx)("div", { children: shipName });
};
const CellContent = ({ transaction, contentKey, isInAdminTools, editTransaction, removeTransaction, handleSeal, handleDownload, userCompanyId, }) => {
    switch (contentKey) {
        case "from":
            return getShipLink(transaction.from.id, transaction.from.name, transaction.from.company_id, isInAdminTools, userCompanyId);
        case "to":
            return getShipLink(transaction.to.id, transaction.to.name, transaction.to.company_id, isInAdminTools, userCompanyId);
        case "total_to_be_paid":
        case "total_to_be_received":
        case "quantity":
        case "alternative_cost":
        case "production_cost":
        case "transaction_cost":
            return (0, jsx_runtime_1.jsx)("div", { children: (0, amountUtils_1.formatNumber)(transaction[contentKey], 2) });
        case "periodical_statement":
            return ((0, jsx_runtime_1.jsx)("div", { children: transaction.periodical_statement
                    ? transaction.periodical_statement.name
                    : "N/A" }));
        case "sealed_at":
            return ((0, jsx_runtime_1.jsx)("div", { children: transaction.sealed_at
                    ? (0, timeUtils_1.formatDate)(new Date(transaction.sealed_at), true)
                    : "" }));
        case "tools":
            return !transaction.sealed_at ? ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Row, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeTransaction(transaction), children: "Remove" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => editTransaction(transaction), children: "Edit" }), handleSeal && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => handleSeal(transaction), children: "Review & seal" }))] })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.Row, { children: handleDownload && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => handleDownload(transaction), children: "Download PDF" })) }));
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: transaction[contentKey] });
    }
};
const TransactionTable = ({ transactions, isInAdminTools, poolId, refresh, }) => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [user] = (0, useFetch_1.default)("user/data.json");
    const [modal, setModal] = (0, react_1.useState)({});
    const [reviewModalOpen, setReviewModalOpen] = (0, react_1.useState)(false);
    const [transactionToReview, setTransactionToReview] = (0, react_1.useState)(null);
    const [, setDownloadUrl, , runDownload] = (0, useFetchBlob_1.default)();
    const [pools, _setPoolsUrl, _setPoolsBody] = (0, useFetch_1.default)(isInAdminTools ? "admin/pools.json" : "pool/pools.json", undefined, true);
    const [ships, _setShipsUrl, _setShipsBody] = (0, useFetch_1.default)(isInAdminTools ? "admin/ships.json" : "ship/ships.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setPoolsBody(JSON.stringify({ pool_id: poolId, year: selectedYear }));
        _setShipsBody(JSON.stringify({ pool_id: poolId, year: selectedYear }));
    }, [poolId, selectedYear]);
    const handleSeal = (transaction) => {
        setTransactionToReview(transaction);
        setReviewModalOpen(true);
    };
    const handleCloseReviewModal = () => {
        setReviewModalOpen(false);
        setTransactionToReview(null);
    };
    const handleDownload = (transaction) => {
        setDownloadUrl(`admin/transaction.sealed.pdf?id=${encodeURIComponent(transaction.id)}`);
        runDownload();
    };
    const pool = pools.status === apiUtils_1.LoaderStatus.Success
        ? pools.data.find((p) => p.id === poolId)
        : undefined;
    const { sortedData, sortMethod, sortDirection, setSort } = (0, useSortedData_1.useSortedData)(transactions, "id", 1);
    const currentYear = new Date().getFullYear();
    const toggleTransactionModal = () => {
        if (modal.type !== undefined) {
            setModal({});
        }
        else {
            setModal({
                type: "add",
                value: {
                    transaction_date: selectedYear !== currentYear
                        ? (0, timeUtils_1.formatToDateInputValue)(new Date(selectedYear, 11, 31))
                        : (0, timeUtils_1.formatToDateInputValue)(new Date()),
                    year: selectedYear,
                    pool_id: poolId ?? undefined,
                },
            });
        }
    };
    const [_editStatus, executeEdit] = (0, useEdit_1.default)("admin/transaction.json", refresh);
    const editTransaction = (transaction) => {
        setModal({
            type: "edit",
            value: {
                ...transaction,
                from: transaction.from.id,
                to: transaction.to.id,
            },
        });
    };
    const removeTransaction = (transaction) => {
        setModal({
            type: "remove",
            value: {
                ...transaction,
                from: transaction.from.id,
                to: transaction.to.id,
            },
        });
    };
    const submit = (type, value) => {
        setModal({});
        const transactionInput = (0, lodash_1.pick)(value, compliance_pool_types_1.transactionInputKeys);
        if (type === "add") {
            if ((0, compliance_pool_types_1.isValidTransactionInput)(transactionInput)) {
                const data = {
                    ...transactionInput,
                    id: null,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("Empty name");
            }
        }
        if (type === "edit") {
            if ((0, compliance_pool_types_1.isValidTransactionInput)(transactionInput)) {
                executeEdit(transactionInput, "PUT");
            }
            else {
                alert("Empty name");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
        }
    };
    const columns = tableColumns(isInAdminTools);
    const csvColumns = columns
        .filter((column) => column.key !== "tools")
        .map((column) => ({
        header: column.label,
        getValue: (transaction) => {
            switch (column.key) {
                case "from":
                    return transaction.from.name;
                case "to":
                    return transaction.to.name;
                case "total_to_be_paid":
                case "total_to_be_received":
                case "quantity":
                case "alternative_cost":
                case "production_cost":
                case "transaction_cost":
                    return (0, amountUtils_1.formatNumber)(transaction[column.key]) ?? "";
                case "periodical_statement":
                    return transaction.periodical_statement
                        ? transaction.periodical_statement.name
                        : "N/A";
                default: {
                    const value = transaction[String(column.key)];
                    return typeof value === "string" || typeof value === "number"
                        ? value
                        : "";
                }
            }
        },
    }));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [ships.status === apiUtils_1.LoaderStatus.Success &&
                pools.status === apiUtils_1.LoaderStatus.Success && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "transaction", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit, pool: pool })), (0, jsx_runtime_1.jsx)(TransactionReviewModal_1.TransactionReviewModal, { isOpen: reviewModalOpen, transaction: transactionToReview, onClose: handleCloseReviewModal, onSealed: refresh }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Row, { gap: 2, children: [isInAdminTools && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { color: theme_1.theme.colors.blue, onClick: () => toggleTransactionModal(), children: "+ Add transaction" })), (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: sortedData, columns: csvColumns, tableName: "transactions" })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.SortableTH, { setSort: setSort, sortKey: c.sortableKey, sortDirection: sortMethod && sortMethod === c.sortableKey
                                    ? sortDirection
                                    : undefined, children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedData.map((transaction, index) => {
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, transaction: transaction, isInAdminTools: isInAdminTools, editTransaction: editTransaction, removeTransaction: removeTransaction, handleSeal: handleSeal, handleDownload: handleDownload, userCompanyId: user.status === apiUtils_1.LoaderStatus.Success
                                            ? user.data.company.id
                                            : undefined }) }, c.key))) }, transaction.id));
                        }) })] })] }));
};
exports.TransactionTable = TransactionTable;
